import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaYoutube = props => {
  if (props.id !== "_svgsocialmediayoutube") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><g fill="#333"><path d="M120 15C62.562 15 16 61.562 16 119s46.562 104 104 104 104-46.562 104-104S177.438 15 120 15zm0 196c-50.729 0-92-41.271-92-92s41.271-92 92-92 92 41.271 92 92-41.271 92-92 92z" /><path d="M176.337 81.566c-4.759-4.984-10.092-5.008-12.536-5.3C146.291 75 120.028 75 120.028 75h-.055s-26.264 0-43.772 1.265c-2.446.292-7.776.316-12.536 5.3-3.751 3.796-4.973 12.418-4.973 12.418s-1.251 10.125-1.251 20.25v9.492c0 10.127 1.251 20.25 1.251 20.25s1.222 8.621 4.973 12.42c4.76 4.982 11.012 4.826 13.796 5.349C87.471 162.703 120 163 120 163s26.291-.039 43.801-1.307c2.444-.291 7.777-.315 12.536-5.299 3.75-3.799 4.974-12.42 4.974-12.42s1.248-10.123 1.248-20.25v-9.492c0-10.124-1.248-20.249-1.248-20.249s-1.224-8.622-4.974-12.417zm-69.253 53.663l-.006-35.153 33.807 17.639-33.801 17.514z" /></g></svg>;
};

SvgSocialmediaYoutube.displayName = "_svgsocialmediayoutube";
SvgSocialmediaYoutube.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaYoutube.defaultProps = {
  id: ''
};
export default SvgSocialmediaYoutube;